import { useAuth0 } from "@auth0/auth0-react";
import { Button } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { ButtonsContainer } from "./styles";
import { AuthContext } from "../../contexts";
import useGetValidAccessToken from "../../hooks/useGetValidAccessToken";
import CircularProgress from "@mui/material/CircularProgress";
import { resendVerificationEmail } from "../../services/emailVerificationService";

export const EmailVerification = (): JSX.Element => {
  const { loginWithRedirect, logout } = useAuth0();
  const { userId } = useContext(AuthContext);
  const { getValidAccessToken } = useGetValidAccessToken();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isReVerificationEmailSent, setIsReVerificationEmailSent] =
    useState(false);

  const onResendEmailVerificationSuccess = () => {
    setIsLoading(false);
    setIsReVerificationEmailSent(true);
  };

  const handleEmailReVerification = async () => {
    setIsLoading(true);
    const token = await getValidAccessToken();
    resendVerificationEmail(token, userId, onResendEmailVerificationSuccess);
  };

  useEffect(() => {
    document.title = "Verify Your Email | OmMuse";
  }, []);
  return (
    <div style={{ height: "50vh" }} className="container">
      <h1 className="settings-header">Verify your Email</h1>
      <p className="settings-text">
        Please check your email account and click the verification link. You
        must verify your email before continuing.
      </p>
      <ButtonsContainer>
        <Button
          variant="contained"
          sx={{ margin: "25px" }}
          onClick={() => {
            loginWithRedirect({
              appState: { targetUrl: "/initial-setting" },
            });
          }}
        >
          Continue
        </Button>
        <Button
          variant="contained"
          sx={{ margin: "25px" }}
          onClick={handleEmailReVerification}
        >
          {isLoading ? (
            <CircularProgress size={20} sx={{ color: "black" }} />
          ) : (
            "Resend Email"
          )}
        </Button>
        <Button
          variant="contained"
          sx={{ margin: "25px" }}
          onClick={() => {
            logout({ returnTo: window.location.origin + "/logout" });
          }}
        >
          Logout
        </Button>
      </ButtonsContainer>
      {isReVerificationEmailSent && (
        <p> A re-verification email has been sent.</p>
      )}
    </div>
  );
};
